import { useDispatch, useSelector } from 'react-redux';
import { media } from '@lifesize/clients.sdk';
import { acquireWebcam } from 'actions/media';
import Logger from 'js-logger';
import { isAcquiringSelector } from 'selectors/media';

export function useAcquireWebcam() {
  const dispatch = useDispatch();
  const isAcquiring = useSelector(isAcquiringSelector);

  return async () => {
    try {
      if (!media.getPrimaryStream() && !isAcquiring) {
        Logger.info('Acquiring Webcam');
        return await dispatch(acquireWebcam());
      } else {
        Logger.info(`Skipping acquiring webcam because (stream acquired: ${!media.getPrimaryStream()} | isAcquiring: ${isAcquiring})`);
      }
    } catch (ex) {
      Logger.warn('Could not capture webcam', ex);
    }
  }
}

export default {
  useAcquireWebcam
};
